(function () {

    angular.module('FotocApp')

        .service('$shutterstock', ['CONSTANTS','$rootScope', '$q', '$timeout', '$http', function (CONSTANTS, $rootScope, $q, $timeout, $http) {

           
            var self = this;
            var canceller = $q.defer();
            var timer;
            var txt_last_search = ''
            var current_page = 0;
            
            var ref_list = []
            this.isLoading = false;

            this.onWatchTxt = function ($list, $txt_search){
                current_page = 0;
                ref_list = $list;
                
                if(angular.isDefined($txt_search)){

                    txt_last_search = $txt_search;
                    canceller.resolve("cancelled");
                    $timeout.cancel(timer);
            
                  
                   if($txt_search == ""){

                     self.isLoading = false;
                     self.noResult = false;
                
                    }else{
                        search($txt_search);
                   }
     
                }else{
 
                    self.isLoading = false;
                    self.noResult = false;
                }
            }


            this.loadMore = function (){
               
                self.isLoading = true;
                search(txt_last_search)
            }
        
            function search($what){
           
            
                $timeout.cancel(timer);

                if($what == "") {
                    self.noResult = false;
                    return;
                }
                timer = $timeout(function (){

                    canceller.resolve("cancelled");
                    canceller = $q.defer();
                    self.isLoading = true;
                    $http.get(  FOTOCEDITOR_API_IMAGES + 'v2/images/search?query=' + $what + '&view=full&page='+ (++current_page) +'&per_page=60&language=es', 
                                { timeout: canceller.promise}).then(function (response) {
                        
                                        $.merge(ref_list, response.data.data);

                                        self.noResult = response.data.total_count == 0
                                        self.isLoading = false;
                                },
                                function (response){ }
                                );


                }, 300)
            }



        }])
        

})();